import SeoMetaData from "common/SeoMetaData"
import ChoosePictureAiPage from "components/CreateAi/ChoosePictureAiPage"

const ChoosePicture = () => {
  const seo = {
    title: "יצירת תמונה ב-AI|איך יצא?",
    description: "חדש! יצירת תמונה של מקדונלד׳ס בהתאמה אישית",
    keywords: "יצירת תמונה ב-AI",
  }

  return (
    <>
      <SeoMetaData data={seo} />
      <ChoosePictureAiPage />
    </>
  )
}

export default ChoosePicture
